import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ConfigContextProvider from './components/ConfigContextProvider';
import LocaleContextProvider from './components/LocaleContextProvider';
import AuthenticationContextProvider from './components/AuthenticationContextProvider';
import * as serviceWorker from './serviceWorker';

const renderApp = (container, configUrl, rootUrl) => {
  ReactDOM.render(
    <React.StrictMode>
      <ConfigContextProvider configUrl={configUrl}>
        <LocaleContextProvider>
          <AuthenticationContextProvider>
            <App rootUrl={rootUrl} />
          </AuthenticationContextProvider>
        </LocaleContextProvider>
      </ConfigContextProvider>
    </React.StrictMode>,
    container
  );
};

if (window.LIBRARY_DISABLE_ROUTING) {
  document.querySelectorAll('.AppSampleRoot').forEach(container => {
    renderApp(container, container.dataset.config, container.dataset.root);
  });
} else {
  renderApp(
    document.getElementById('root'),
    window.LIBRARY_CONFIG_URL,
    window.LIBRARY_ROOT_URL
  );
}

serviceWorker.unregister();
